import React, { useState } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Headroom from "react-headroom"
import styled from "styled-components"
import Logo from "../../svg/logo.svg"
import { BraveHamburger, DeskNav, MobileNav } from "./"

const StyledHeader = styled(Headroom)`
  z-index: 99999 !important;
  position: relative;
  header {
    --color: ${(props) => (props.$reverseHeader ? "#000000" : "#ffffff")};
    --logoColor: ${(props) => (props.$reverseHeader ? "#000000" : "#ffffff")};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem ${(props) => props.theme.padding.headerMobile};
    z-index: 999;
    background: transparent;
    transition: 0.2s all ease;

    svg {
      width: 90px;
      fill: var(--color);
      color: var(--color);
    }
    button svg {
      width: auto;
      font-size: 2em;
    }
    .trev-logo svg {
      fill: var(--logoColor);
      color: var(--logoColor);
    }
    .demo-button {
      background: #6eb25b;
      margin-left: 10px;
      margin-top: 0px;
    }
  }
  .headroom--pinned {
    header {
      --color: #fff;
      --logoColor: #fff;
      background: ${(props) => props.theme.colors.brandColor};
      a.login-button {
        background: #fff;
        color: ${(props) => props.theme.colors.brandColor};
      }
    }
  }
  @media ${(props) => props.theme.breakpoints.large} {
    header {
      padding: 1.5rem ${(props) => props.theme.padding.hDesk};
      svg {
        width: 120px;
      }
      .menu-toggle {
        display: none;
      }
    }
  }
`

export const Header = ({ $reverseHeader = false }) => {
  const { prismicNavigation } = useStaticQuery(graphql`
    query {
      prismicNavigation {
        data {
          main_navigation {
            nav_title
            page_reference {
              type
              url
              document {
                ... on PrismicSubNavigation {
                  id
                  data {
                    nav_items {
                      nav_title
                      icon {
                        url
                      }
                      feature_link
                      page_reference {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
  const { main_navigation } = prismicNavigation?.data
  const [navOpen, setNavOpen] = useState(false)
  return (
    <>
      <StyledHeader $reverseHeader={$reverseHeader}>
        <header>
          <Link to="/" className="trev-logo">
            <Logo />
          </Link>
          <DeskNav items={main_navigation} />
          <button
            aria-label="menu-toggle"
            onClick={() => setNavOpen(!navOpen)}
            className="menu-toggle"
          >
            <BraveHamburger menuState={navOpen} />
          </button>
        </header>
      </StyledHeader>
      <MobileNav menuState={navOpen} items={main_navigation} />
    </>
  )
}
